import React from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Button from "@material-ui/core/Button";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Tooltip from "@material-ui/core/Tooltip";
import PeopleOutlineOutlinedIcon from "@material-ui/icons/PeopleOutlineOutlined";
import { BrowserRouter as Router, Link, withRouter } from "react-router-dom";
import "./menu.css";
import { PrivateRoute } from "../../routing";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import ScheduleIcon from "@material-ui/icons/Schedule";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AuthService from "../../services/auth";
import SettingMenu from './setting-menu';
import AdbIcon from '@material-ui/icons/Adb';

const drawerWidth = 69;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: '0px 16px 9px',
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));

const PersistentDrawerLeft = ({ history }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [] = React.useState({ users: [], rooms: [] });
  const permissions = AuthService.getPermission();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [, setAnchorEl] = React.useState(null);

  const logout = () => {
    AuthService.signout();
    history.push("/login");
  };

  return (
    <Router>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, open && classes.hide)}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap></Typography>
            <div className="right-area">
              {localStorage.getItem("username") + " "}
              <Button color="secondary" onClick={logout}>
                <ExitToAppIcon />
              </Button>
              <SettingMenu />
            </div>
          </Toolbar>
        </AppBar>
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerHeader}>
            <IconButton className="left-button" onClick={handleDrawerClose}>
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </div>
          <List>
            <ListItem button key="1">
              <Link to="/devices">
                <Tooltip title="Danh sách device">
                  <ListItemIcon>
                    <DashboardOutlinedIcon fontSize="large" />
                  </ListItemIcon>
                </Tooltip>
                {/* device */}
              </Link>
              {/* <ListItemText primary="Devices" /> */}
            </ListItem>
            {permissions.canEdit && (
              <ListItem button key="2">
                <Tooltip title="Đặt lịch">
                  <Link to="/calendar">
                    <ListItemIcon>
                      <ScheduleIcon fontSize="large" />
                    </ListItemIcon>
                  </Link>
                </Tooltip>
                {/* <ListItemText primary="Abcde" /> */}
              </ListItem>
            )}
            {permissions.canEdit && (
              <ListItem button key="3">
                <Tooltip title="Danh sách tài khoản">
                  <Link to="/users">
                    <ListItemIcon>
                      <PeopleOutlineOutlinedIcon fontSize="large" />
                    </ListItemIcon>
                  </Link>
                </Tooltip>
                {/* <ListItemText primary="Abcde" /> */}
              </ListItem>
            )}
             {permissions.canEdit && (
              <ListItem button key="4">
                <Tooltip title="Automatic mode">
                  <Link to="/intel-mod">
                    <ListItemIcon>
                      <AdbIcon fontSize="large" />
                    </ListItemIcon>
                  </Link>
                </Tooltip>
                {/* <ListItemText primary="Abcde" /> */}
              </ListItem>
            )}
          </List>
        </Drawer>
        <main style={{padding: '0px 16px 9px'}}
          className={clsx(classes.content, {
            [classes.contentShift]: open,
          })}
        >
          <div className={classes.drawerHeader} />
          <div>
            {/* <AppRouter /> */}
            <PrivateRoute />
          </div>
        </main>
      </div>
    </Router>
  );
};

const MenuHolder = withRouter(({ history }) => (
  <PersistentDrawerLeft history={history} />
));

export default MenuHolder;
